'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, Link, browserHistory } from 'react-router'
import { i18n } from 'react-i18n'
import AppStore from '../stores/AppStore'
import TemplateData from '../utility/getTemplateData'
import PostTransaction from '../confirmation/postTransaction'
import * as FPT from '../utility/fpt'

let PropTypes = React.PropTypes

export default React.createClass({

	mixins: [i18n('confirmation/pending')],

	propTypes:{
		label: React.PropTypes.string
	},

	getInitialState () {

		let confirmationData = AppStore.getConfirmation() || {}

		return {
			amount: confirmationData.amount || '',
			postBackData: confirmationData.postBackData || {},
			displayMyAccount: confirmationData.showAccountOverview || false,
			orgName : (TemplateData.donationName) ? TemplateData.donationName : '',

			autoRedirect : TemplateData.returnAutoRedirect !== '',
			autoRedirectUrl : (TemplateData.charityReturnUrl) ? TemplateData.charityReturnUrl : '',
			autoRedirectMethod: (TemplateData.returnMethod) ? TemplateData.returnMethod : ''
		};
	},

	componentDidMount () {

		this.serverRequest = $.post('/donate/guest/postTransaction', {}).then(function(response) {
			$('.spinneroverlay').hide();
			if(response.data.confirmationData){
				// AppActions.updateConfirmation({ confirmation: result.data.confirmationData });
				this.setState({
					amount: response.data.confirmationData.amount || AppStore.getDonationAmount(),
					guestSignUp: response.data.confirmationData.guestSignUp || false ,
					displayMyAccount: response.data.confirmationData.showAccountOverview || false
				})
			}

		}.bind(this))

		let confData = AppStore.getConfirmation() || {}
		let trid = confData.confirmationNumber || '';

		if (TemplateData.fptPageName === 'guestULSignUp') {
			FPT.trackPage('main:donate:wps:signup:pending', 'main:donate:wps:signup:pending:web::', 'trid', trid)
		} else {
			FPT.trackPage('main:donate:wps:guest:pending', 'main:donate:wps:guest:pending:web::', 'trid', trid)
		}
	},

	componentWillUnmount () {
		this.serverRequest.abort()
	},

	render () {

		let yourdonation = this.i18n('label.yourdonation')
		let returnText = this.i18n('label.returnTextMember')
		let returnto = this.i18n('label.returnto')
		let myAccount = this.i18n('label.myAccount')
		let pending = this.i18n('label.pending')
		let pending2 = this.i18n('label.pending2')

		yourdonation = yourdonation.split('<br>')[0]
		yourdonation = yourdonation.replace('{amount}', this.state.amount)
		returnText = returnText.replace('{orgName}', this.state.orgName)

		returnto = returnto.replace('{orgName}', this.state.orgName)

		return (
			<div>
				<div className="donate_wrapper">
					<div className="row confirmation">
						<div className="col-xs-12 col-sm-12 col-md-12">
							<div className="confirmation_img_holder center-block">
								<span className="icon icon-large icon-attention-large" aria-hidden="true"></span>
							</div>
						</div>

						<div className="col-xs-12 col-sm-12 col-md-12">
							<div className="confirmation_header">
								<h4 className="text-center">{pending}</h4>
								<h5 style={{ marginTop: 15, lineHeight: '1.6', fontWeight: '200' }} className="text-center">{pending2}</h5>
							</div>
						</div>

						{this.state.autoRedirect ?
							<div>
								<div className="col-xs-12 col-sm-12 col-md-12">
									<div className="confirmation_reciept_wrapper">
										<h6 className="text-center">{returnText}</h6>
									</div>
									<div className="text-center">
										<a id="returnUrl" href={this.state.autoRedirectUrl} className="btn btn-primary pp_guest_btn">{returnto}</a>
									</div>
								</div>
								<PostTransaction
									orgName={this.state.orgName}
									postdata={this.state.postBackData}
									method={this.state.autoRedirectMethod}
									action={this.state.autoRedirectUrl}/>
							</div> : null}
						{this.state.guestSignUp ? <div></div> : null}
						{(this.state.displayMyAccount && !this.state.autoRedirect) ?
							<div className="col-xs-12 col-sm-12 col-md-12 text-center">
								<div className="pp_guest_btn_wrapper">
									<a href="/myaccount" className="btn btn-primary pp_guest_btn">{myAccount}</a>
								</div>
							</div>: null}
					</div>
				</div>
			</div>
		);
	}
});



// WEBPACK FOOTER //
// ./guest/pending.js